var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFurn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 1600 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "north"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 -21v16h70z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 3,
    d: "M63 0A63 63 0 1 0 -63 0 63 63 0 1 0 63 0zM0 -75v150 M-75 0h150 "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "dr"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M-5 -43h10v3h-10zM-5 43h10v-3h-10zM5 -40h80v4h-80z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M5 40A81 81 0 0 0 85 -36 "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "fr"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M60 -30h-60v60h60z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M23 7l3 -5h-5 M28 9l2 -4 2 4 M39 -2h-5l3 -5 M28 -9l2 4 2 -4 M37 7l-3 -5h5 M21 -2h5l-3 -5 M26 -2l8 4 M34 -2l-8 4 M30 -5v10 M55 30v-60v60 M55 30v-60 "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "wc"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M17 20h35A20 20 0 0 0 52 -20h-35A3 3 0 0 0 14 -22h-14v44h14A3 3 0 0 0 17 20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M11 0A2 2 0 1 0 7 0 2 2 0 1 0 11 0zM17 -20A126 126 0 0 1 17 20 M52 -20l-28 4v32l28 4 "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "bi"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M54 0A17 17 0 0 1 47 15 31 31 0 0 1 32 19 138 138 0 0 1 5 16l-5 -1v-30l5 -1A138 138 0 0 1 32 -19 31 31 0 0 1 47 -15 17 17 0 0 1 54 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M8 0A2 2 0 1 0 4 0 2 2 0 1 0 8 0zM21 0A2 2 0 1 0 16 0 2 2 0 1 0 21 0zM45 12A14 14 0 0 0 51 0 14 14 0 0 0 45 -12 22 22 0 0 0 32 -15l-18 2A4 4 0 0 0 11 -9v18A4 4 0 0 0 14 13l18 2A22 22 0 0 0 45 12zM2 14v-28 "
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "wc2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M0 18h35A18 18 0 1 0 35 -18h-35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M35 -18l-28 4v28l28 4 "
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "wc3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M15 18h35A18 18 0 1 0 50 -18h-35zM0 -30h15v60h-15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M50 -18l-28 4v28l28 4 "
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "st"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M60 -30h-60v60h60z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M11 -15h-4 M15 -7v-4 M11 15h-4 M15 23v-4 M15 11v-4 M23 15h-4 M41 15h-4 M45 23v-4 M15 -19v-4 M23 -15h-4 M41 -15h-4 M45 -7v-4 M45 11v-4 M53 15h-4 M45 -19v-4 M53 -15h-4 M53 -15A8 8 0 1 0 37 -15 8 8 0 1 0 53 -15zM53 15A8 8 0 1 0 37 15 8 8 0 1 0 53 15zM23 15A8 8 0 1 0 7 15 8 8 0 1 0 23 15zM23 -15A8 8 0 1 0 7 -15 8 8 0 1 0 23 -15z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M60 -15h-60v30h60z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M53 0A8 8 0 1 0 37 0 8 8 0 1 0 53 0zM11 0h-4 M15 8v-4 M11 0h-4 M15 8v-4 M23 0A8 8 0 1 0 7 0 8 8 0 1 0 23 0zM15 -4v-4 M23 0h-4 M41 0h-4 M45 8v-4 M15 -4v-4 M23 0h-4 M41 0h-4 M45 8v-4 M45 -4v-4 M53 0h-4 M45 -4v-4 M53 0h-4 "
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "dw"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M60 -30h-60v60h60z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M33 11A8 8 0 0 1 32 1 10 10 0 0 0 32 -9 M27 9A9 9 0 0 1 27 -1 8 8 0 0 0 27 -11"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "dw2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M60 -22h-60v44h60z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M33 11A8 8 0 0 1 32 1 10 10 0 0 0 32 -9 M27 9A9 9 0 0 1 27 -1 8 8 0 0 0 27 -11 "
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "wm"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M60 -30h-60v60h60z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M55 30v-60 M33 -9A10 10 0 0 1 34 8 2 2 0 1 1 31 4 8 8 0 0 0 33 -9zM27 9A10 10 0 0 1 26 -8 2 2 0 1 1 29 -4 8 8 0 0 0 27 9z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "wm2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M45 -30h-45v60h45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M25 -9A10 10 0 0 1 26 8 2 2 0 1 1 23 4 8 8 0 0 0 25 -9zM19 9A10 10 0 0 1 18 -8 2 2 0 1 1 20 -4 8 8 0 0 0 19 9zM40 30v-60"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "wm3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M60 -15h-60v30h60z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M30 -9A10 10 0 0 1 32 8 2 2 0 1 1 29 4 8 8 0 0 0 30 -9zM25 9A10 10 0 0 1 23 -8 2 2 0 1 1 26 -4 8 8 0 0 0 25 9zM55 15v-30"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "sh"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M0 -80v80h80v-80z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M23 -21A2 2 0 1 0 18 -21 2 2 0 1 0 23 -21zM5 -75v70h70v-70z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "ba"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M0 0h160v-70h-160z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M5 -15A10 10 0 0 0 15 -5h110A30 30 0 0 0 125 -65h-110A10 10 0 0 0 5 -55zM17 -35A2 2 0 1 0 13 -35 2 2 0 1 0 17 -35zM19 -35A4 4 0 1 0 11 -35 4 4 0 1 0 19 -35z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "si1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M0 -50v100h60v-100z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M8 -8A9 9 0 0 0 15 0h30A9 9 0 0 0 53 -7v-31A9 9 0 0 0 45 -45h-30A9 9 0 0 0 8 -38zM8 45v-35 M13 45v-35 M18 45v-35 M23 45v-35 M28 45v-35 M33 45v-35 M38 45v-35 M43 45v-35 M48 45v-35 M53 45v-35 M20 -10A2 2 0 1 0 15 -10 2 2 0 1 0 20 -10z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "si2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M60 98v-150h-60v150z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M8 -40v30A9 9 0 0 0 15 -2h30A9 9 0 0 0 53 -10v-30A9 9 0 0 0 45 -47h-30A9 9 0 0 0 8 -40zM53 93v-35 M48 93v-35 M43 93v-35 M38 93v-35 M33 93v-35 M28 93v-35 M23 93v-35 M18 93v-35 M13 93v-35 M8 93v-35 M20 -12A2 2 0 1 0 15 -12 2 2 0 1 0 20 -12zM20 13A2 2 0 1 0 15 13 2 2 0 1 0 20 13zM8 10v30A9 9 0 0 0 15 48h30A9 9 0 0 0 53 40v-30A9 9 0 0 0 45 3h-30A9 9 0 0 0 8 10z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "si"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M0 -30v60h60v-60z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M16 23h28A9 9 0 0 0 53 14v-28A9 9 0 0 0 44 -23h-28A9 9 0 0 0 7 -14v28A9 9 0 0 0 16 23zM20 0A2 2 0 1 0 15 0 2 2 0 1 0 20 0z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "si3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M7 -15A9 9 0 0 1 15 -22h30A9 9 0 0 1 52 -15v62h-45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M25 44v-18 M30 26v18 M35 44v-18 M7 15A9 9 0 0 0 15 22h30A9 9 0 0 0 52 15 M20 0A2 2 0 1 0 15 0 2 2 0 1 0 20 0z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "wb"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M44 -60h-43A1 1 0 0 0 0 -59v58A1 1 0 0 0 1 0h43A1 1 0 0 0 45 -1v-58A1 1 0 0 0 44 -60z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M21 -30A3 3 0 1 0 15 -30 3 3 0 1 0 21 -30zM7 -60v60 M38 -58h-25A4 4 0 0 0 9 -53v46A4 4 0 0 0 13 -2h25A4 4 0 0 0 42 -7v-46A4 4 0 0 0 38 -58z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "ba2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M0 0h180v-70h-180z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M94 -35A4 4 0 1 0 86 -35 4 4 0 1 0 94 -35zM92 -35A2 2 0 1 0 88 -35 2 2 0 1 0 92 -35zM145 -65h-110A30 30 0 0 0 35 -5h110A30 30 0 0 0 145 -65z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "de"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M-75 -85h150v85h-150zM-22 -85v-22h44v22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M-22 -105h44 "
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "b2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M191 -90A11 11 0 0 1 200 -81v162A11 11 0 0 1 191 90h-177A11 11 0 0 1 5 81v-162A11 11 0 0 1 14 -90zM5 -90v180h-5v-180h5 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M11 -77v73h40v-73zM51 4h-40v73h40zM79 45v-135 M56 -90v75A98 98 0 0 0 79 45 72 72 0 0 1 99 90 M56 -13A73 73 0 0 0 63 40 77 77 0 0 1 78 90 "
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "b21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M191 -90A11 11 0 0 1 200 -81v162A11 11 0 0 1 191 90h-177A11 11 0 0 1 5 81v-162A11 11 0 0 1 14 -90zM5 -90v180h-5v-180h5 M0 -135h45v45h-45v-45 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M11 -77v73h40v-73zM51 4h-40v73h40zM79 45v-135 M56 -90v75A98 98 0 0 0 79 45 72 72 0 0 1 99 90 M56 -13A73 73 0 0 0 63 40 77 77 0 0 1 78 90 "
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "b22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M191 -90A11 11 0 0 1 200 -81v162A11 11 0 0 1 191 90h-177A11 11 0 0 1 5 81v-162A11 11 0 0 1 14 -90zM5 -90v180h-5v-180h5 M45 90h-45v45h45v-45 M0 -135h45v45h-45v-45 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M11 -77v73h40v-73zM51 4h-40v73h40zM79 45v-135 M56 -90v75A98 98 0 0 0 79 45 72 72 0 0 1 99 90 M56 -13A73 73 0 0 0 63 40 77 77 0 0 1 78 90 "
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "b1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M193 0A7 7 0 0 1 200 7v86A7 7 0 0 1 193 100h-186A7 7 0 0 1 0 93v-86A7 7 0 0 1 7 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M5 13v74h42v-74h-42 M75 68v-68 M96 100A37 37 0 0 0 75 68 50 50 0 0 1 52 28v-28 M52 28A62 62 0 0 0 59 64 82 82 0 0 1 74 100 "
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "f1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M0 -94v94h93v-12h4v-70h-4v-12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M17 -82v70 M93 -82h-85v70h85 "
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "f2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M0 -164v164h93v-12h4v-140h-4v-12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M17 -82h80 M17 -152v140 M93 -152h-85v140h85 "
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "f3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M0 -234v234h93v-12h4v-210h-4v-12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M17 -82h80 M17 -152h80 M17 -222v210 M93 -222h-85v210h85 "
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "f4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M0 -304v304h93v-12h4v-280h-4v-12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M17 -222h80 M17 -82h80 M17 -152h80 M17 -292v280 M93 -292h-85v280h85 "
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "dc"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M-30 -30h60v60h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M-13 0A5 5 0 1 0 -23 0 5 5 0 1 0 -13 0zM-18 25l13 -7 -7 -13 -13 7z"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "t2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M-75 45h150v-90h-150zM-55 -45v-26h45v26zM10 -45v-26h45v26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M10 -69h45 M-55 -69h45 "
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "t3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M-22 23h-50v-45h50zM-22 -22v-50h44v50zM22 -22h50v44h-50zM22 23v50h-44v-50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M37 0A37 37 0 1 0 -37 0 37 37 0 1 0 37 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M22 70h-44 M70 -22v44 M-22 -70h44 M-70 23v-45 "
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "t4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M-75 45h150v-90h-150zM-55 -45v-26h45v26zM10 -45v-26h45v26zM55 45v26h-45v-26zM-10 45v26h-45v-26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M-10 69h-45 M55 69h-45 M10 -69h45 M-55 -69h45 "
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "t5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M-75 45h150v-90h-150zM-55 -45v-26h45v26zM10 -45v-26h45v26zM75 -22h26v44h-26zM55 45v26h-45v-26zM-10 45v26h-45v-26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M-10 69h-45 M55 69h-45 M99 -22v44 M10 -69h45 M-55 -69h45 "
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "t6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M-75 45h150v-90h-150zM-55 -45v-26h45v26zM10 -45v-26h45v26zM-75 22h-26v-44h26zM75 -22h26v44h-26zM55 45v26h-45v-26zM-10 45v26h-45v-26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M-10 69h-45 M55 69h-45 M99 -22v44 M-99 22v-44 M10 -69h45 M-55 -69h45 "
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "t7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M88 69h-45 M43 -69h45 M-43 69h-45 M22 69h-44 M-22 -69h44 M-88 -69h45 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M-98 45h196v-90h-196zM-88 -45v-26h45v26zM-22 -45v-26h44v26zM22 45v26h-44v-26zM-43 45v26h-45v-26zM43 -45v-26h45l-1 26zM87 45l1 26h-45v-26z"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "tv"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M80 0h-160v-40h160z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M-60 -20h120 M60 -20v-4h-120v4l4 4h112z"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "tvs"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M60 -20v-4h-120v4l4 4h112z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M-60 -20h120 "
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "tc"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M45 0A45 45 0 1 0 -45 0 45 45 0 1 0 45 0z"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "r2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M-42 -45h84v90h-84zM22 45v25h-44v-25zM-22 -45v-25h44v25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M-22 -68h44 M22 68h-44 "
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "r3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M-42 -45h84v90h-84zM-23 -45v-25h46l-1 25zM-42 23h-26v-45h26zM42 -23h26v45h-26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M65 -23v45 M-65 23v-45 M-23 -68h46 "
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "r4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M-42 -45h84v90h-84zM22 45v25h-44v-25zM-22 -45v-25h44v25zM-42 23h-25v-45h25zM42 -23h25v45h-25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M65 -23v45 M-65 23v-45 M-22 -68h44 M22 68h-44 "
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "r5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M-42 -45h84v90h-84zM-22 -45v-25h44v25zM42 -23h25v45h-25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M65 -23v45 M-22 -68h44 "
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "chr"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M50 23h-50v-46h50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M3 -23v46"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFurn);
export default __webpack_public_path__ + "static/media/furn.ffbaa964b8c907c6dac2fb8d430fa3f8.svg";
export { ForwardRef as ReactComponent };